import { DEFAULT_LOCALE, SUPPORTED_UOU_LOCALES } from './consts';

export const getUoULocale = (locale: string) =>
  SUPPORTED_UOU_LOCALES.indexOf(locale) > -1 ? locale : DEFAULT_LOCALE;
